import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ShippingLabelMessagesInput')
export class ShippingLabelMessages {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('slm') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  reference1: string

  @Field(() => String)
  @Prop({ type: String })
  reference2: string

  @Field(() => String)
  @Prop({ type: String })
  reference3: string
}
